import { redirect, createFileRoute } from '@tanstack/react-router';

// /dashboard/.../emails/create — kept only as a redirect to /create, which now
// authors email, SMS and MMS rather than email alone. The path outlived its
// meaning: /emails/create implied SMS was a detour from email instead of a peer
// of it.
//
// Search is forwarded verbatim so the links that carry a handoff into this
// surface (?prompt, ?autoGenerate, ?productVariantIds, ?mediaAssetIds) keep
// working from bookmarks, the dashboard input box and anything already shared.

export const Route = createFileRoute('/_authed/dashboard/o/$orgId/c/$clientId/emails/create')({
  // Passthrough rather than omitted: without a validateSearch of its own this
  // route would only see the search its parents declared, and the handoff
  // params would be dropped on the way through the redirect.
  validateSearch: (search: Record<string, unknown>) => search,
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/dashboard/o/$orgId/c/$clientId/create',
      params: { orgId: params.orgId, clientId: params.clientId },
      search: search as never,
    });
  },
});
